import { render, staticRenderFns } from "./edit-role.vue?vue&type=template&id=8778b0a8"
import script from "./edit-role.vue?vue&type=script&lang=ts"
export * from "./edit-role.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports